export default __webpack_public_path__ + "static/media/mobile-app.f9b7b27e.png";